var _templateObject = _taggedTemplateLiteralLoose(['\n  position: absolute;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  bottom: 5%;\n  width: 100%;\n'], ['\n  position: absolute;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  bottom: 5%;\n  width: 100%;\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n  position: absolute;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 100%;\n'], ['\n  position: absolute;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 100%;\n']);

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component, Children } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import SwipeableView from 'react-swipeable-views';

var Carousel = function (_Component) {
  _inherits(Carousel, _Component);

  function Carousel() {
    var _temp, _this, _ret;

    _classCallCheck(this, Carousel);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = { activeIndex: 0 }, _this.onChangeIndex = function (index, indexLatest, meta) {
      _this.setState({
        activeIndex: index
      });
    }, _this._moveLeft = function () {
      var activeIndex = _this.state.activeIndex;

      var nextIndex = activeIndex - 1;
      _this.setState({
        activeIndex: nextIndex < 0 ? activeIndex : nextIndex
      });
    }, _this._moveRight = function () {
      var activeIndex = _this.state.activeIndex;
      var children = _this.props.children;

      var nextIndex = activeIndex + 1;
      var length = Children.count(children);
      _this.setState({
        activeIndex: nextIndex + 1 > length ? activeIndex : nextIndex
      });
    }, _this._slideToIndex = function (index) {
      _this.setState({
        activeIndex: index
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Carousel.prototype.render = function render() {
    var _this2 = this;

    var activeIndex = this.state.activeIndex;
    var _props = this.props,
        Dot = _props.dotComponent,
        Button = _props.buttonComponent,
        innerRef = _props.innerRef,
        children = _props.children;


    var slides = Children.toArray(children);

    return React.createElement(
      'div',
      { ref: innerRef, style: { position: 'relative' } },
      React.createElement(
        SwipeableView,
        {
          onChangeIndex: this.onChangeIndex,
          index: activeIndex,
          springConfig: {
            duration: '.8s',
            easeFunction: 'cubic-bezier(0.15, 0.3, 0.25, 1)',
            delay: '0s'
          }
        },
        children
      ),
      Button && slides.length !== 1 && React.createElement(
        ButtonContainer,
        null,
        React.createElement(Button, { onClick: this._moveLeft, left: true }),
        React.createElement(Button, { onClick: this._moveRight, right: true })
      ),
      Dot && slides.length > 1 && React.createElement(
        DotsContainer,
        null,
        slides.map(function (slide, i) {
          var isActive = i === activeIndex;
          return React.createElement(Dot, {
            key: i,
            isActive: isActive,
            onClick: function onClick() {
              return _this2._slideToIndex(i);
            }
          });
        })
      )
    );
  };

  return Carousel;
}(Component);

export { Carousel as default };
Carousel.propTypes = process.env.NODE_ENV !== "production" ? {
  dotComponent: PropTypes.func,
  buttonComponent: PropTypes.func,
  className: PropTypes.string
} : {};


var DotsContainer = styled.ul(_templateObject);
var ButtonContainer = styled.div(_templateObject2);